import index from "./scss-syntax.js"

export default index

export const stringify = index.stringify
export const parse = index.parse
